// T-239 — seconde barrière, côté écran, avant d'afficher le HTML d'un mail REÇU. Le serveur l'a déjà assaini (liste blanche) ;
// ici on le RECONSTRUIT balise par balise dans un document inerte (DOMParser : ni script, ni image chargée) : jamais de retrait par motif.
// Rien ne passe hors liste blanche : pas de style, pas d'événement, pas d'image, seulement http(s) / mailto / tel pour un lien.
const BALISES = new Set([
  "p", "br", "div", "span", "b", "strong", "i", "em", "u", "s", "strike", "sub", "sup", "small", "big", "blockquote", "pre", "code",
  "hr", "ul", "ol", "li", "dl", "dt", "dd", "table", "thead", "tbody", "tfoot", "tr", "td", "th", "caption",
  "h1", "h2", "h3", "h4", "h5", "h6", "a",
]);
const SUPPRIMEES = new Set([
  "script", "style", "iframe", "frame", "frameset", "object", "embed", "applet", "noscript", "template", "svg", "math", "head",
  "title", "textarea", "select", "option", "button", "audio", "video", "canvas", "map", "noembed", "xmp", "plaintext",
  "img", "picture", "source", "link", "meta", "base", "form", "input",
]);
const VIDES = new Set(["br", "hr"]);
const PROFONDEUR_MAX = 60;
const PROFONDEUR_ABSOLUE = 150;
const SCHEMA_SUR = /^(https?:\/\/|mailto:|tel:)/i;
// eslint-disable-next-line no-control-regex
const CONTROLES = new RegExp("[\\u0000-\\u0020\\u007f-\\u009f\\u200b-\\u200f\\u2028\\u2029\\ufeff]+", "g");

// Mise en forme par les jetons de la charte (2 modes) : la feuille de style de l'application remet à zéro liens, listes et tableaux.
const STYLES = {
  a: "color: var(--oh-accent-text); text-decoration: underline",
  ul: "list-style: disc; padding-left: var(--oh-space-6); margin: 0 0 var(--oh-space-2)",
  ol: "list-style: decimal; padding-left: var(--oh-space-6); margin: 0 0 var(--oh-space-2)",
  blockquote: "margin: 0 0 var(--oh-space-2) var(--oh-space-2); padding-left: var(--oh-space-3); border-left: 2px solid var(--oh-border); color: var(--oh-text-secondary)",
  td: "padding: var(--oh-space-1) var(--oh-space-2); vertical-align: top",
  th: "padding: var(--oh-space-1) var(--oh-space-2); vertical-align: top; font-weight: 500",
  p: "margin: 0 0 var(--oh-space-2)",
  pre: "white-space: pre-wrap; margin: 0 0 var(--oh-space-2)",
  h1: "font-weight: 500; font-size: 16px; margin: 0 0 var(--oh-space-2)",
  h2: "font-weight: 500; font-size: 15px; margin: 0 0 var(--oh-space-2)",
  h3: "font-weight: 500; font-size: 14px; margin: 0 0 var(--oh-space-2)",
  h4: "font-weight: 500; margin: 0 0 var(--oh-space-2)",
  h5: "font-weight: 500; margin: 0 0 var(--oh-space-2)",
  h6: "font-weight: 500; margin: 0 0 var(--oh-space-2)",
  b: "font-weight: 500",
  strong: "font-weight: 500",
};

export function urlSure(valeur) {
  const nette = String(valeur || "").replace(CONTROLES, "");
  if (!nette || nette.length > 2000 || !SCHEMA_SUR.test(nette)) return "";
  return nette;
}

function copier(noeud, cible, doc, profondeur) {
  if (profondeur > PROFONDEUR_ABSOLUE) return;   // au-delà : abandon (la récursion ne dépend jamais de la profondeur d'un mail piégé)
  noeud.childNodes.forEach((n) => {
    if (n.nodeType === 3) { cible.appendChild(doc.createTextNode(n.nodeValue)); return; }
    if (n.nodeType !== 1) return;
    const tag = n.tagName.toLowerCase();
    if (SUPPRIMEES.has(tag)) return;
    if (!BALISES.has(tag) || profondeur >= PROFONDEUR_MAX) { copier(n, cible, doc, profondeur + 1); return; }
    const el = doc.createElement(tag);
    if (tag === "a") {
      const href = urlSure(n.getAttribute("href"));
      if (href) { el.setAttribute("href", href); el.setAttribute("target", "_blank"); el.setAttribute("rel", "noopener noreferrer nofollow"); }
    } else if (tag === "td" || tag === "th") {
      ["colspan", "rowspan"].forEach((a) => { const v = n.getAttribute(a); if (v && /^\d{1,3}$/.test(v)) el.setAttribute(a, v); });
    }
    if (STYLES[tag]) el.setAttribute("style", STYLES[tag]);
    if (!VIDES.has(tag)) copier(n, el, doc, profondeur + 1);
    cible.appendChild(el);
  });
}

export function neutraliserHtml(brut) {
  if (!brut || typeof brut !== "string") return "";
  const source = new DOMParser().parseFromString(brut, "text/html");
  const doc = document.implementation.createHTMLDocument("");
  copier(source.body, doc.body, doc, 0);
  return doc.body.innerHTML;
}
